import type { FaireProductEntity } from "../../entity_types/product";

export const p_fk97jc6xyc: FaireProductEntity = {
  token: "p_fk97jc6xyc",
  type: "product",
  name: "French Lavender Shower Steamers",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/ee75c21e9dbea9e15808ff8638ca5077568bfab86b715c74f87db27932108f37.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cea12816621ed58c2525ef00402ec1900c82bab6e7147aadf0d52540771b541c.jpeg",
    "https://cdn.faire.com/fastly/a240adaadd0b86bfcba3bbd114c0516b7149a6d6bd7e4da6243884980e17212d.jpeg",
    "https://cdn.faire.com/fastly/b871326299178a2da7b9b46aa53f25d91a58297c2160590051afd7406ed98e7c.jpeg",
    "https://cdn.faire.com/fastly/18b820147be9eaf992ff98a5449808a1440f25430e28bd7dbfa0009105033ce4.jpeg",
    "https://cdn.faire.com/fastly/bd86f3a33c6a28d321eaf4704f015119c81401e600c6e2c9164af22b10b89d81.jpeg",
    "https://cdn.faire.com/fastly/882b13049cfcb463f82455631ea4a901a1da7e6f768f1445732ff8fe49b628f1.jpeg",
    "https://cdn.faire.com/fastly/af91dd5f03cd0ee150492a6092fe19ae368aef8c8edae91a0d743c9de1d84cd9.jpeg",
    "https://cdn.faire.com/fastly/71ffaacf998e9e77ec25a8628f2e62d872422d447f9a0ba5ba2125c187ccea0a.jpeg",
  ],
  priceDollars: 8,
  description:
    "Our French Lavender Shower Steamers create a soothing and relaxing experience, creating a spa-like atmosphere in your shower! Simply place a shower steamer on the floor of your shower and let the steam transform your daily shower experience into a luxurious oasis! Handmade in Charleston, SC.\n\nEach box contains 4 individual shower steamers weighing 3oz each.\n\nOur French Lavender scent is a tranquil, floral blend with notes of mountain heather and wild rose. Our favorite fragrance for inspiring sleep and serenity, this soothing scent is reminiscent of a gentle breeze rolling through a peaceful meadow of wild lavender.\n\nAny Old Whaling Company shower steamer will make a great gift! Our French Lavender Shower Steamers are a great for year-round gifts - perfect for hostess gifts, birthday gifts, and baby shower gifts!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:22.609Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
